import { useApplicationField } from '../useApplicationField';

// ─── Application ──────────────────────────────────────────────────────────────

export const usePausePoint = () =>
    useApplicationField(
        (d) => d.information.pausePoint,
        (d, v) => ({ ...d, information: { ...d.information, pausePoint: v } })
    );

export const useBorrowerEsignAcknowledgeFontName = () =>
    useApplicationField(
        (d) => d.information?.borrower?.esign?.acknowledgeFontName ?? '',
        (d, v) => ({
            ...d,
            information: {
                ...d.information,
                borrower: { ...d.information?.borrower, esign: { ...d.information?.borrower?.esign, acknowledgeFontName: v } },
            },
        })
    );

export const useApplicationProperties = () =>
    useApplicationField(
        (d) => d.information.properties,
        (d, v) => ({ ...d, information: { ...d.information, properties: v } })
    );

export const useApplicationPropertyForms = () =>
    useApplicationField(
        (d) => d.information.properties?.forms ?? [],
        (d, v) => ({ ...d, information: { ...d.information, properties: { ...d.information.properties, forms: v } } })
    );
